export default __webpack_public_path__ + "static/media/lyubo_s.675f8e43.jpg";